import React from 'react';
import PropTypes from 'prop-types';
import withTheme from '../shared/progressIndicators/withTheme';

export const ProgressBar = ({
  submitted,
  quota,
  height,
  emptyColor,
  completedColor,
}) => {
  const completedPercentage = Math.floor((submitted / quota) * 100);
  const completedPercentageString =
    submitted === 0 ? `1%` : `${completedPercentage}%`;
  return (
    <svg height={height} width="100%">
      <g>
        <rect fill={emptyColor} width="100%" height="100%" />
        <rect
          fill={completedColor}
          width={completedPercentageString}
          height="100%"
        />
      </g>
    </svg>
  );
};

ProgressBar.propTypes = {
  submitted: PropTypes.number,
  quota: PropTypes.number,
  height: PropTypes.string,
  emptyColor: PropTypes.string,
};

export default withTheme(ProgressBar);
